import { path } from "./path";

import type { IExtendedRouteObject } from "@routes/types.ts";
import { useUIStore } from "@/stores/uiStore";

export const profileManagementRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: path.editProfile.route,
      lazy: () =>
        import("@/pages/panelPages/doctorProfileManagement/doctor/doctorPM"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.editProfile", [], "edit");
        return {};
      },
    },
    permissions: ["doctor"],
  },
  {
    route: {
      path: path.viewProfile.route,
      lazy: () =>
        import("@/pages/panelPages/doctorProfileManagement/doctor/doctorPM"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.viewProfile", [], "view");
        return {};
      },
    },
    permissions: ["doctor"],
  },
  {
    route: {
      path: path.editProfile.route,
      lazy: () =>
        import("@/pages/panelPages/doctorProfileManagement/staff/staffPM"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.editProfile", [], "edit");
        return {};
      },
    },
    permissions: ["staff"],
  },
  {
    route: {
      path: path.viewProfile.route,
      lazy: () =>
        import("@/pages/panelPages/doctorProfileManagement/staff/staffPM"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.viewProfile", [], "view");
        return {};
      },
    },
    permissions: ["staff"],
  },
  {
    route: {
      path: path.editProfile.route,
      lazy: () =>
        import("@/pages/panelPages/doctorProfileManagement/patient/patientPM"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.editProfile", [], "edit");
        return {};
      },
    },
    permissions: ["patient"],
  },
  {
    route: {
      path: path.viewProfile.route,
      lazy: () =>
        import("@/pages/panelPages/doctorProfileManagement/patient/patientPM"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.viewProfile", [], "view");
        return {};
      },
    },
    permissions: ["patient"],
  },
  {
    route: {
      path: path.editProfile.route,
      lazy: () =>
        import(
          "@/pages/panelPages/doctorProfileManagement/localAdmin/localAdminPM"
        ),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.editProfile", [], "edit");
        return {};
      },
    },
    permissions: ["local-admin"],
  },
  {
    route: {
      path: path.viewProfile.route,
      lazy: () =>
        import(
          "@/pages/panelPages/doctorProfileManagement/localAdmin/localAdminPM"
        ),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.viewProfile", [], "view");
        return {};
      },
    },
    permissions: ["local-admin"],
  },
  {
    route: {
      path: path.editProfile.route,
      lazy: () =>
        import("@/pages/panelPages/doctorProfileManagement/admin/adminPM"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.editProfile", [], "edit");
        return {};
      },
    },
    permissions: ["admin"],
  },
  {
    route: {
      path: path.viewProfile.route,
      lazy: () =>
        import("@/pages/panelPages/doctorProfileManagement/admin/adminPM"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.viewProfile", [], "view");
        return {};
      },
    },
    permissions: ["admin"],
  },
  {
    route: {
      path: path.editProfile.route,
      lazy: () =>
        import(
          "@/pages/panelPages/doctorProfileManagement/superAdmin/superAdminPM"
        ),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.editProfile", [], "edit");
        return {};
      },
    },
    permissions: ["super-admin"],
  },
  {
    route: {
      path: path.viewProfile.route,
      lazy: () =>
        import(
          "@/pages/panelPages/doctorProfileManagement/superAdmin/superAdminPM"
        ),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.viewProfile", [], "view");
        return {};
      },
    },
    permissions: ["super-admin"],
  },
  {
    route: {
      path: path.editProfile.route,
      lazy: () => import("@/pages/panelPages/doctorProfileManagement/msp/page"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.editProfile", [], "edit");
        return {};
      },
    },
    permissions: [
      "medical-service-provider-lab",
      "medical-service-provider-drug",
      "medical-service-provider-image",
    ],
  },
  {
    route: {
      path: path.viewProfile.route,
      lazy: () => import("@/pages/panelPages/doctorProfileManagement/msp/page"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.viewProfile", [], "view");
        return {};
      },
    },
    permissions: [
      "medical-service-provider-lab",
      "medical-service-provider-drug",
      "medical-service-provider-image",
    ],
  },
  // add other profile management pages like above. just change the permission and page component
];
